export const GRAPH_COLORS = {
    green: "#52c41a",
    gold: "#FAAD14",
    magenta: "#eb2f96",
    purple: "#722ed1",
    red: "#f5222d",
    yellow: "#fadb14",
    blue: "#2f54eb",
    cyan: "#13c2c2",
    volcano: "#fa541c",
    graphite: "#475569",
    bordeaux: "#9F1239",
};

export const ENTITY_BASED_ENABLED_COLOR = "#27272a";
export const ENTITY_BASED_DISABLED_COLOR = "#a3a3a3";

export const LOCAL_STORAGE_KEY = "paldock_highlights";

export const X_AXIS_KEY = "datetime_at";

export const MAX_HIGHLIGHTS_COUNT = 10;
